/* eslint-disable import/no-cycle */
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  banks: [],
  branches: [],
  tillAccount: [],
  vaultAccount: [],
  financialDate: {},
  corporateDetails: {},
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
